import { useEffect, useState, useRef } from "react";
import { useTitle } from "../hooks/useTitle";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../firebase/config";
import { PostCard, SkeletonCard } from "../components";

export const HomePage = () => {
  /* const posts = [
    {id: 1, title: "Lorem ipsum dolor sit amet.", description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Soluta et iste deleniti. Qui corporis odit quisquam ducimus dicta nam debitis repellat dolorem reiciendis expedita facere labore ab modi at dolore molestias, nulla explicabo sapiente aliquid. Aliquam inventore corporis labore perferendis atque nesciunt, sit itaque! Iure earum vel corrupti voluptatibus incidunt?", author: "Levi"},
    {id: 2, title: "Lorem ipsum dolor sit amet.", description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Soluta et iste deleniti. Qui corporis odit quisquam ducimus dicta nam debitis repellat dolorem reiciendis expedita facere labore ab modi at dolore molestias, nulla explicabo sapiente aliquid. Aliquam inventore corporis labore perferendis atque nesciunt, sit itaque! Iure earum vel corrupti voluptatibus incidunt?", author: "Imma"},
  ] */

  const [posts, setPosts] = useState(new Array(2).fill(false));//const [posts, setPosts] = useState([]);
  const [toggle, setToggle] = useState(false);
  useTitle("Home");
  const postsRef = useRef(collection(db, "posts"));

  useEffect(() => {
    async function getPosts(){
      const data = await getDocs(postsRef.current);
      setPosts(data.docs.map((document) => (
        {...document.data(), id: document.id}
        )
      ));
    }
    getPosts();
  }, [postsRef, toggle]);


  return (
    <section>
      { posts.map((post, index) => (
        post ? (<PostCard key={post.id} post={post} toggle={toggle} setToggle={setToggle} />) : 
        (
          <SkeletonCard key={index}/>
        )
        
      )) }
    </section>
  )
}
